var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.local !== undefined && this.$route.path !== '/login')?_c('div',[_c('MenuComponent')],1):_vm._e(),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view',{staticClass:"mt-0"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }